import {
  ActionPlanTaskInfo,
  RawActionPlanTaskInfo,
} from '../models/action-plan-task';

export function mapActionPlanTaskInfo(
  raw: RawActionPlanTaskInfo,
): ActionPlanTaskInfo {
  const info: ActionPlanTaskInfo = {};
  info.isDependentActivities = raw.IsDependentActivities;
  info.completeDelay = raw.CompleteDelay;
  info.incompletePrecedingMessage = raw.strHidIncompletePrecedingMessage;
  info.dependentRescheduleMessage = raw.strHidDependentRescheduleMessage;
  return info;
}
